export interface ITicketTotals  {
    MyTickets: number;
    UnclaimedTickets: number;
}

export class TicketTotalsArray extends Array<TicketTotals>  {

    constructor(...items: TicketTotals[]) {
        super(...items);
        Object.setPrototypeOf(this, TicketTotalsArray.prototype);
    }

}

export class TicketTotals implements ITicketTotals {
    MyTickets: number;
    UnclaimedTickets: number;
}
